module.exports = __webpack_public_path__ + "static/img/ent-47.5d45105.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-47.jpg
// module id = AL0n
// module chunks = 52